import { CLIENT_SOFTWARE } from '../constant/actionTypes';

const getClientSoftwareChartData = (state, action) => {
  switch (action.type) {
    case CLIENT_SOFTWARE.GET.INITIATE:
      return { isFetching: false };
    case CLIENT_SOFTWARE.GET.SUCCESS:
      return { isFetching: true, data: action.payload };
    case CLIENT_SOFTWARE.GET.ERROR:
      return action.payload;
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getClientSoftwareChartData;
